import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WriteForm from '@calendar/components/Edit/WriteForm.vue'
import { AlarmModal, StartDateModal, EndDateModal, FolderModal, MeetingRoomModal, StartTimeModal, EndTimeModal } from '../components/Modals'
import * as dateutil from '@/util/date-helper'
import api from '@calendar/api'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as types from '@calendar/store/types'
import * as accountTypes from '@account/store/types'

@Component({
    components: { 
        WriteForm,
        AlarmModal,
        StartDateModal,
        EndDateModal, 
        FolderModal, 
        MeetingRoomModal, 
        StartTimeModal,
        EndTimeModal
    },
    computed: {
        ...mapGetters({
          User: accountTypes.USER,
          item: types.CURRENT_CALENDAR_ITEM,
          currentRecurring: types.CALENDAR_CURRENT_RECURRING,
          folderListTree: types.FOLDER_LIST_TREE
        })
    },
    methods: {
        ...mapActions({
          editCalendar: types.CALENDAR_EVENT_EDIT,
        }),
        ...mapMutations({
          setCalendarItem: types.CURRENT_CALENDAR_ITEM
        }),
    },
})
export default class EditContainer extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  User!: account.User
  item!: calendar.CalendarItem
  currentRecurring!: calendar.CalendarItemRecurrence
  folderListTree!: any

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: A C T I O N S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  editCalendar!: (item: calendar.CalendarItem) => Promise<boolean>

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  setCalendarItem!: (item: calendar.CalendarItem) => void

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  // 이수 - 회의실 목록에 db 자원관리 회의실 목록과 연동
  conferenceList: calendar.ConferenceResourceItem[] = [];
  conferenceId: number | string = ''
  reserveRequestId: number | null = null
  selectConference: calendar.ConferenceResourceItem | null = null
  
  reserveRequestItem: calendar.RequestCalendarMapItem | null = null
  conference: any | null = null

  isConferenceReserveCreate: boolean = false

  email: mail.WriteEmailData = ({
    subject: '',
    to: [],
    cc: [],
    bcc: [],
    body: '',
    attachments: '',
    isBigfile: false,
    code: '',
    codeValues: [],
    importance: 'Normal',
    security: 'Normal',
    whenToSend: '',
  } as unknown) as mail.WriteEmailData
  editItem: calendar.CalendarItem = {
    parentId: '',
    //attachments: [] as any,
    hasAttachments: false,
    body: '',
    location: '',
    subject: '',
    status: 'S0',
    appointmentType: 'Single',
    pidLidRecurrenceType: 1,
    ui_resourceArray: [] as Array<any>,
    resourceId: null,
    resources: [] as Array<any>,
    recurrence: {
      // startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
      // endDate: dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.uGetDate(90)),
      // ui_useRecurringButton: true,
      // ui_useDefaultDate: true,
      // ui_useRecurringDisplay: false,
      // ui_useRecurring: false,
      // ui_recurringType: 1,
      // monthValue: new Date().getMonth() + 1,
      // firstDayOfWeekValue: 1,
      // daysOfTheWeekArray: [] as number[],
      // ui_endType: '1',
      // interval: 1,
      // numberOfOccurrences: 0,
    } as calendar.CalendarItemRecurrence,
    code: '',
    codeValues: [] as string[],
    importance: 'Normal',
    isCancelled: false,
    isRecurring: false,
    isAllDayEvent: false,
    isAllowUpdate: true,
    start: dateutil.uGetDateFormat('yyyy-MM-DDTH:i:00', new Date()),
    end: dateutil.uGetDateFormat('yyyy-MM-DDTH:i:00', new Date()),
    starttime: '',
    endtime: '',
    requiredAttendees: [] as any,
    optionalAttendees: [] as any,
    isReadyData: false,
    reminderMinutesBeforeStart: 15,
  } as calendar.CalendarItem

  folderName: string = ''

  receiver: string = ''

  showRecurrChange: boolean = false

  startTimeArray: Array<any> = []
  endTimeArray: Array<any> = []

  durationText: string = ''

  showRecurringOption!: boolean
  savedEndDate: string | null = null
  savedNumberOfOccurrences: number = 0

  treeItems!: any
  RoomList!: any
  parentIdFlag: boolean = false

  selectedFolderID: string = ''
  useSendMail: boolean = false
  FdisplayName: string = ''

  isImportanceModalShow: boolean = false
  isStatusModalShow: boolean = false
  isRepeatModalShow: boolean = false
  localRecurrence: calendar.CalendarItemRecurrence = {
    // startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
    // endDate: dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.uGetDate(90)),
    // ui_useRecurringButton: true,
    // ui_useDefaultDate: true,
    // ui_useRecurringDisplay: false,
    // ui_useRecurring: false,
    // ui_recurringType: 1,
    // monthValue: new Date().getMonth() + 1,
    // firstDayOfWeekValue: 1,
    // daysOfTheWeekArray: [] as number[],
    // ui_endType: '1',
    // dayOfMonth: 1,
    // interval: 1,
  } as calendar.CalendarItemRecurrence
  RecurringType: '1' | '2' | '3' | '4' = '1'
  EndType: '1' | '2' | '3' = '1'
  WeekCheckboxArray: Array<any> = [{ flag: false, value: 0, text: '' }]
  showDelay: boolean = false

  //FolderName: string = ''
  CantClick: boolean = false

  backup_starttime: string = ''
  backup_endtime: string = ''
  saveItem: calendar.CalendarItem | null = null

  showStartDateModal: boolean = false
  showEndDateModal: boolean = false
  showStartTimeModal: boolean = false
  showEndTimeModal: boolean = false
  showMeetingRoomModal: boolean = false
  showFolderModal: boolean = false
  showAlarmModal: boolean = false

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  isWeekChecked(index: number) {
    if (!this.localRecurrence.daysOfTheWeekArray) {
      return false
    }

    return this.localRecurrence.daysOfTheWeekArray?.indexOf(index) != -1
  }

  selectFolder(id: string, displayName: string) {
    this.selectedFolderID = id
    this.editItem.parentId = this.selectedFolderID
    this.FdisplayName = displayName
    this.setCalendarItem(this.editItem)
  }

  /**
   * 참석자 태그
   * @param list
   */
  convertRecToTag(list?: mail.EwsRecipient[]) {
    return (
      list?.map((r) => ({
        text: r.name,
        value: r.address,
      })) || []
    )
  }

  /**
   * 참석자 태그
   * @param list
   */
   convertTagToRec(list?: any[]) {
    return (
      list?.map((r) => ({
        name: r.text,
        address: r.value,
        deptName: r.displayDeptName,
        personCode: r.personCode,
      })) || []
    )
  }

  async edit() {
    const editItem = {
      ...this.editItem,
    } as calendar.CalendarItem
    if (editItem) {
      if (
        !editItem.isEWS &&
        editItem.appointmentType != 'Occurrence' &&
        editItem.appointmentType != 'Exception' &&
        editItem.recurrence.ui_useRecurring
      ) {
        editItem.appointmentType = 'RecurringMaster'
        editItem.isRecurring = true
      } else if (!editItem.isEWS && !editItem.recurrence.ui_useRecurring) {
        editItem.appointmentType = 'Single'
        editItem.isRecurring = false
      }

      if (editItem.isAllDayEvent) {
        editItem.starttime = '00:00:00'
        editItem.endtime = '00:00:00'

        // 하루종일 체크했을 때 만약 start와 end날짜가 같다면 end날짜를 +1시켜주기
        let eDate = dateutil.IEDate(editItem.end)
        eDate.setDate(eDate.getDate() + 1)
        editItem.end = dateutil.uGetDateFormat('yyyy-MM-DD', eDate)
      }
      //20201207
      //Object.assign(editItem.recurrence, this.localRecurrence)

      editItem.requiredAttendees = this.convertTagToRec(this.email.to)
      editItem.optionalAttendees = this.convertTagToRec(this.email.cc)

      if (!editItem.isEWS && editItem.appointmentType == 'Occurrence') {
        editItem.appointmentType = 'Exception'
      }

      if ((window as any).currentEditor) {
        editItem.body = (window as any).currentEditor.getContent()
      }

      // 자원예약 승인 되지 않은것은 수정/삭제 불가 (부킹 테이블에 없는경우...)
      if (this.reserveRequestItem && !this.reserveRequestItem.approvalStatus) {
        await(window as any).alertAsync(this.$t('승인_대기_중입니다').toString())
        return false;
      }

      // 회의실 예약하는 경우 유효성 체크 -> 일정 등록  -> 자원예약 등록
      if (this.selectConference) {

        if (editItem.recurrence.ui_useRecurring) {
          await(window as any).alertAsync( this.$t("회의실_예약시에는_반복일정을_사용할_수_없습니다.").toString())

          return false
        }

        if (editItem.requiredAttendees.length == 0) {
          await(window as any).alertAsync( this.$t("필수_참석자는_1명이상_지정되어야_합니다").toString())
           
          return false
        }

        // 다른 회의실 예약하려는건지 확인
        if (this.reserveRequestItem && (this.selectConference.resourceId != this.reserveRequestItem.reserveResourceId)) {
          await(window as any).alertAsync('회의실 변경이 불가합니다.')
          return false
        }

        let startDate = this.item.start
        let startTime = this.item.starttime
        let endDate = this.item.end
        let endTime = this.item.endtime

        //종일인경우 체크해야됨
        if (this.item.isAllDayEvent == true) {
          //종일 옵션이 체크된 경우 값 변경 해야됨
          //시작시작은 00:00:00 으로 
          //종료시간은 23:59:59 로
          startTime = "00:00:00"
          endDate = startDate
          endTime = "23:59:59"
        }

        api.db_resourceReserve.validationReserveRequestIncludeWait({
          reserveRequestId: this.reserveRequestId,//this.requestInfo?.reserveRequestId,
          reserveResourceId: <number>this.selectConference?.resourceId,
          startDatetime: new Date(`${startDate}T${startTime}`),
          endDatetime: new Date(`${endDate}T${endTime}`),
          recurringOption: null//recurringOption ? recurringOption : null
        }).then(async result => {
          if (result == false) {
            await(window as any).alertAsync('선택하신 시간에는 이미 예약되어 있습니다.')
            return false
          } else {
            this.setCalendarItem(editItem)
            this.editCalendar(editItem).then((res) => {
              if (res) {
                // 회의실 예약하는 경우 ( 자원예약 연동건이든 아니든 자원예약 저장으로 보냄 create 또는 update 하도록)
                this.conferenceReserveSave()
              }
            })
          }
        })
      } else {
        this.setCalendarItem(editItem)
        this.editCalendar(editItem).then((res) => {
          if (res) {
            // 회의실 예약이였는데 삭제한 경우
            if (this.reserveRequestItem && !this.selectConference) {
              this.conferenceReserveDelete()
            } else {
              this.$router.push('/calendar/main')
            }
          }
        })
      }
    }
  }

  conferenceReserveSave() {
    // //에디터 content 입력
    // this.reserveContent = this.item.body
    // let options = this.currentReccuringOption
    // debugger
    // return
    // //예약 시작 유효청 체크
    // //시작일시는 종료일시보다 크거나 같을 수 없음
    // if (this.valueValidation() == false) {
    //     this.contentLoaded = true
    //     return
    // }

    let startDate = this.item.start
    let startTime = this.item.starttime
    let endDate = this.item.end
    let endTime = this.item.endtime

    // let isRecursive = false
    // let recurringOption: reservedb.RequestRequestOption | null = null
    // //반복설정 
    // //반복설정이 된 경우
    // if (this.currentReccuringOption != null) {

    //     isRecursive = true

    //     //weekArray 가 타입이 다름 
    //     //database 에 row 로 입력되기 때문에 sperator(",") 추가해서 입력해야됨
    //     //string[] 로 변경해서 전달
    //     let weekArray = ""
    //     if (this.currentReccuringOption.daysOfTheWeekArray &&
    //         this.currentReccuringOption.daysOfTheWeekArray.length > 0) {
    //         const lastItem = this.currentReccuringOption.daysOfTheWeekArray[this.currentReccuringOption.daysOfTheWeekArray.length - 1]
    //         this.currentReccuringOption.daysOfTheWeekArray.forEach(week => {

    //             //마지막 아이템인 경우 , sperator 생략
    //             weekArray += week.toString() + (week == lastItem ? "" : ",")
    //         })
    //     }

    //     recurringOption = {
    //         recuringType: <ReserveRecuringType>this.currentReccuringOption.ui_recurringType,
    //         recuringEndType: <ReserveRecuringEndType>parseInt(this.currentReccuringOption.ui_endType),
    //         recuringStartDate: this.currentReccuringOption.startDate,
    //         recuringEndDate: this.currentReccuringOption.endDate,
    //         recuringInterval: this.currentReccuringOption.interval,
    //         recuringCount: this.currentReccuringOption.numberOfOccurrences,
    //         recuringDayOfMonth: this.currentReccuringOption.dayOfMonth,
    //         recuringDayOfWeekArray: weekArray,
    //         recuringMonth: this.currentReccuringOption.monthValue
    //     }

    // }

    //종일인경우 체크해야됨
    if (this.item.isAllDayEvent == true) {
      //종일 옵션이 체크된 경우 값 변경 해야됨
      //시작시작은 00:00:00 으로 
      //종료시간은 23:59:59 로
      startTime = "00:00:00"
      endDate = startDate
      endTime = "23:59:59"
    }

    let requestTargets = this.item.requiredAttendees.map((item: any) => {
      let isDepartment = false
      if (item.displayName == item.deptName) isDepartment = true

      return {
          personCode: item.personCode,
          isOptional: false,
          isDepartment: isDepartment
      }
    })

    let requestOptionalTargets = this.item.optionalAttendees.map((item: any) => {
      let isDepartment = false
      if (item.displayName == item.deptName) isDepartment = true

      return {
          personCode: item.personCode,
          isOptional: true,
          isDepartment: isDepartment
      }
    })

    const resName =  this.selectConference?.displayName

    let inputData = {
      recursiveDescription: null,//this.recurrenceDesc + "\n" + this.recurrenceIntervalDesc,
      reserveResourceId: this.selectConference?.resourceId,
      title: this.item.subject,
      body: this.item.body,
      fileCode: this.item.hasAttachments ? this.item.code : '', //this.files.length > 0 ? this.uploaderConfig.code : "",
      isRecursive: false,//this.item.isRecurring,
      startDate: startDate,
      startTime: startTime,
      endDate: endDate,
      endTime: endTime,
      requestPersonCode: this.User.personCode,
      isCancel: false,
      approvalStatus: 0,
      option: null, //recurringOption,
      targets: [...requestTargets, ...requestOptionalTargets],
      resourceName : resName
    } as any

    // //업데이트의 경우 requestId, bookingId 추가
    // if (this.requestInfo != null) {
      if (this.reserveRequestItem) {
          inputData.reserveRequestId = this.reserveRequestId
          //inputData.bookingId = this.reserveRequestItem.resourceBookingId //booking id는 삭제할때만 필요
      }

    //   //반복일정 중 단건 처리 시 필요 param
    //   var openQueryVal = this.$route.query.open
    //   if (this.requestInfo.isRecursive == true && this.isOccurrence == true) {
    //       inputData.bookingId = parseInt(<string>this.$route.query.bookingId)
    //       inputData.isOccurrence = true
    //   }

    // }

    let action: Promise<any> = Promise.resolve()

    // 자원예약 연동건인 경우
    if (this.reserveRequestItem) {
      action = api.db_resourceReserve.updateReserveRequest(inputData)
    // 자원예약 연동건 아닌데 회의실 지정한 경우 자원예약 신규
    } else {
      this.isConferenceReserveCreate = true
      action = api.db_resourceReserve.createReserveRequest(inputData)
    }

    action.then(result => {
      console.log('result', result)
      // create면 result가 reserveRequestId 값
      // update면 result가 boolean 값
      
      var actionResult = false
      if (this.reserveRequestId) { //create
        actionResult = result
      } else { //update
        if (result > 0) {
          this.reserveRequestId = result // 생성된 reserveRequestId 값 할당
          actionResult = true
        }
      }

      if (result) {

          var data: any = {
            reserveRequestId: this.reserveRequestId,
            reserveResourceId: this.selectConference?.resourceId,
            calendarItemId: this.item.id
          }

          let mapAction: Promise<any> = Promise.resolve()

          // 자원예약 연동건인 경우
          if (!this.isConferenceReserveCreate) {
            mapAction = api.db_resourceReserve.updateReserveRequestCalendarMap(data)
          // 자원예약 연동건 아닌데 회의실 지정한 경우 자원예약 신규
          } else {
            mapAction = api.db_resourceReserve.createReserveRequestCalendarMap(data)
          }
          mapAction.then(async result => {
            if (result) {
              let msg = this.$t("자원예약이_등록되었습니다").toString()
          
              if (this.selectConference?.useApproval) {
                  //결재 사용 자원인경우 등록 할 때 메세지 추가 처리
                  
                  msg += `\n${this.$t("자원예약_승인_이후에_자원이_예약됩니다").toString()}`
              }
              await(window as any).alertAsync(msg)

              this.$router.push('/calendar/main')
            } else {
              await(window as any).alertAsync( this.$t("자원예약_등록이_실패하였습니다").toString())
            }
          })
        }


    }).finally(() => {
      
    })



  }

  // 부킹테이블에서 삭제
  conferenceReserveDelete() {

    // if (!await(window as any).confirmAsync(this.$t("정말_취소하시겠습니까").toString())) return

    //this.contentLoaded = false
    //취소인데 선택일정일 때만 bookingItem 만 삭제 한다.

    //const { bookingId, open } = this.$route.query

    let reqParam: any = {
        bookingId: this.reserveRequestItem?.resourceBookingId,
        target: 1 //booking:1, request:0
    }


    api.db_resourceReserve.cancelReserveRequest(reqParam).then(async result => {

        if (result == true) {
          var reserveRequestId = 0
          if (this.reserveRequestItem) {
            reserveRequestId = this.reserveRequestItem.reserveRequestId
          }
          api.db_resourceReserve.deleteReserveRequestCalendarMap(reserveRequestId).then(async res => {
            if (res) {
              // await(window as any).alertAsync(this.$t("예약이_취소되었습니다").toString())
              this.$router.push('/calendar/main')
            } else {
              await(window as any).alertAsync(this.$t("예약이_취소가_실패하였습니다").toString())
            }
            
          })
          
            
        } else {
            await(window as any).alertAsync(this.$t("예약이_취소가_실패하였습니다").toString())
            
        }
    }).finally(() => {
        // this.contentLoaded = true
        // this.onCancelClick()
    })
  }

  async load() {
    let _target = this.$route.query.target || this.item.target
    let _id = (this.$route.query.itemid as string) || this.item.id
    let _occitem = (window as any).opener?.occitem || (this.$route.query.occitem as string)
    let sitem: calendar.CalendarItem | null = null

    if (_occitem) {
      sitem = JSON.parse(decodeURIComponent(_occitem)) as calendar.CalendarItem
    }

    let action: Promise<any> =
      _target != 'MY' && _target != 'SHARE'
        ? sitem != null && sitem.appointmentType == 'Exception'
          ? api.db_calendar.getRCalendarEvent({
              ID: Number(sitem.id),
              PersonCode: (this.User as any).personCode,
            })
          : api.db_calendar.getCalendarEvent({
              ID: Number(_id),
              PersonCode: (this.User as any).personCode,
            })
        : api.ews_calendar.getDetail(_id)

    action
      .then(async (citem) => {
        if (sitem != null && sitem.db_masterID && sitem.appointmentType != 'Exception') {
          citem = {
            ...citem,
            ...sitem,
          }
        }

        if (citem.code) {
          const uid = 'uid-' + citem.code.split('uid-')[1]
          citem.codeValues = [this.User.comCode, 'Calendar', this.User.email, uid]
        }

        citem.isAllowAccept = false
        citem.isAllowCancel = false
        citem.isAllowDecline = false
        citem.isAllowDelete = false
        citem.isAllowUpdate = false
        if (_target == 'MY') {
          if (citem.allowedResponseActions) {
            citem.isAllowAccept = citem.allowedResponseActions.indexOf('Accept') != -1
            citem.isAllowDecline = citem.allowedResponseActions.indexOf('Decline') != -1
            citem.isAllowCancel = citem.allowedResponseActions.indexOf('Cancel') != -1
          }

          citem.isAllowUpdate = citem.organizer?.address == this.User.email
          citem.isAllowDelete = true || citem.organizer?.address == this.User.email

          if (citem.isAllowCancel) {
            let repCount =
              (citem.requiredAttendees || []).filter((x: any) => x.address != this.User.email)
                .length +
              (citem.optionalAttendees || []).filter((x: any) => x.address != this.User.email)
                .length
            if (!repCount) {
              citem.isAllowCancel = false
            } else {
              if (
                [...citem.requiredAttendees, ...citem.optionalAttendees].filter(
                  (x) => !x.address || x.address.indexOf('@') == -1
                ).length
              ) {
                citem.isAllowCancel = false
              }
            }
          }
        } else {
          if (_target == 'CM') {
            if (citem.update) {
              citem.isAllowUpdate = citem.organizer?.address == this.User.email
            }

            if (citem.delete) {
              citem.isAllowDelete = citem.organizer?.address == this.User.email
            }
          } else if (_target == 'DC') {
            citem.isAllowUpdate = citem.organizer?.address == this.User.email
            citem.isAllowDelete = citem.organizer?.address == this.User.email
          }
        }

        citem.parentId = (citem as any).parentFolderId

        if (citem.start && (citem.start.indexOf(' ') != -1 || citem.start.indexOf('T') != -1)) {
          citem.starttime = dateutil.DateAndTimeSplitor(citem.start)[1]
          citem.start = dateutil.DateAndTimeSplitor(citem.start)[0]
        }

        if (citem.end && (citem.end.indexOf(' ') != -1 || citem.end.indexOf('T') != -1)) {
          citem.endtime = dateutil.DateAndTimeSplitor(citem.end)[1]
          citem.end = dateutil.DateAndTimeSplitor(citem.end)[0]
        }

        if (typeof citem.isAllDayEvent === 'string') {
          citem.isAllDayEvent = (citem.isAllDayEvent as any) === 'True' ? true : false
          // 하루종일 일정일 경우 end에서 하루를 빼줘야 함
          if (citem.isAllDayEvent) {
            let eDate = dateutil.IEDate(citem.end)
            eDate.setDate(eDate.getDate() - 1)
            citem.end = dateutil.uGetDateFormat('yyyy-MM-DD', eDate)
          }
        }
        // if (typeof citem.isAllDayEvent == typeof '') {
        //     citem.isAllDayEvent = citem.isAllDayEvent as any === 'True' ? true : false;
        // }

        citem.requiredAttendees = this.convertRecToTag(citem.requiredAttendees) as any
        citem.optionalAttendees = this.convertRecToTag(citem.optionalAttendees) as any

        console.log('citem.requiredAttendees', citem.requiredAttendees)
        this.email.to = citem.requiredAttendees
        this.email.cc = citem.optionalAttendees

        if (!citem.recurrence) {
          citem.recurrence = Object.create(null)
          Object.assign(citem.recurrence, this.item.recurrence)
          citem.pidLidRecurrenceType = 1
        }

        if (citem.pidLidRecurrenceType) {
          citem.recurrence.ui_recurringType = citem.pidLidRecurrenceType
        }

        switch (citem.appointmentType) {
          case 'Single':
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = false
            citem.recurrence.ui_useRecurring = false
            break
          case 'RecurringMaster':
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = false
            citem.recurrence.ui_useRecurringDisplay = true
            citem.recurrence.ui_useRecurring = true
            break
          case 'Occurrence':
          case 'Exception':
            citem.recurrence.ui_useRecurringButton = false
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = true
            citem.recurrence.ui_useRecurring = true
            break
          default:
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = false
            citem.recurrence.ui_useRecurring = false
            break
        }
        this.editItem = {
          ...this.item,
          ...citem,
        }

        if (this.editItem.isEWS) {
          var ewsPromise: Promise<any>[] = [
            api.ews_resource.getRooms(),
            api.ews_calendar.getBody(citem.id),
          ]

          await Promise.all(ewsPromise).then((res) => {
            this.editItem.ui_resourceArray = [
              { text: 'None', value: null },
              ...res[0]
                .filter((x: any) => x.depth == 1)
                .map((x: any) => {
                  return { text: x.name, value: x.address }
                }),
            ]
            this.editItem.isReadyData = true
            this.editItem.body = res[1]
          })
        } else {
          await api.db_resource.getFindCalendarResource({ Type: 'RM' }).then((res) => {
            this.editItem.ui_resourceArray = [
              { text: 'None', value: null },
              ...res.map((x) => {
                return { text: x.displayName, value: x.id }
              }),
            ]
            this.editItem.isReadyData = true
          })
        }

        //Object.assign(this.localRecurrence, this.currentRecurring)
      })
      .catch((err) => {
        console.log('editMountError', err)
      })
      .finally(() => {
        //this.setCalendarItem(this.editItem)
      })
  }

  /**
   * '하루종일' 체크 여부에 따라 동작하는 함수입니다
   * @param value
   */
  @Watch('item.isAllDayEvent')
  onAllDayEventChanged(value: boolean) {
    if (value) {
      this.backup_starttime = this.item.starttime
      this.backup_endtime = this.item.endtime
      this.item.starttime = '00:00:00'
      this.item.endtime = '00:00:00'
      this.item.isAllDayEvent = true
      this.CantClick = true
    } else if (this.backup_starttime && this.backup_endtime) {
      this.item.starttime = this.backup_starttime
      this.item.endtime = this.backup_endtime
      this.CantClick = false
    }
  }
  @Watch('item.starttime')
  onStartTimeChanged() {
    if (this.saveItem?.starttime) {
      this.item.starttime = this.saveItem.starttime
    }
  }

  @Watch('item.endtime')
  onEndTimeChanged() {
    if (this.saveItem?.endtime) {
      this.item.endtime = this.saveItem.endtime
      console.log('시간2', this.item.endtime)
    }
  }

  @Watch('item.start')
  onStartChanged() {
    if (this.saveItem?.start) {
      this.item.start = this.saveItem.start
    }
  }

  @Watch('item.end')
  onEndChanged() {
    if (this.saveItem?.end) {
      this.item.end = this.saveItem.end
    }
  }

  @Watch('item.subject')
  onSubjectChanged() {
    if (this.saveItem?.subject) {
      this.item.subject = this.saveItem.subject
    }
  }

  @Watch('item.location')
  onLocatinChanged() {
    if (this.saveItem?.location) {
      this.item.location = this.saveItem.location
    }
  }

  setStartTime(time: string) {
    this.item.starttime = time
    this.showStartTimeModal = false
  }

  setEndTime(time: string) {
    this.item.endtime = time
    this.showEndTimeModal = false
  }

  setFolder(folder: any) {
    this.item.parentId = folder.id
    this.folderName = folder.displayName
    this.showFolderModal = false
  }

  setMeetingRoom(room: any) {
    //this.item.resources = [{name: room.text, address: room.value}];
    //this.item.location = room.text
    this.selectConference = room
  }

  setReminder(number: number) {
    this.item.reminderMinutesBeforeStart = number;
    this.showAlarmModal = false;
  }

  showModal(value: string) {
    eval('this.$data.' + value + ' = true')
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  
  mounted() {
    Object.assign(this.localRecurrence, this.item.recurrence)

    this.load()

    if (
      this.item.start &&
      (this.item.start.indexOf(' ') != -1 || this.item.start.indexOf('T') != -1)
    ) {
      this.item.starttime = dateutil.DateAndTimeSplitor(this.item.start)[1]
      this.item.start = dateutil.DateAndTimeSplitor(this.item.start)[0]
    }

    if (this.item.end && (this.item.end.indexOf(' ') != -1 || this.item.end.indexOf('T') != -1)) {
      this.item.endtime = dateutil.DateAndTimeSplitor(this.item.end)[1]
      this.item.end = dateutil.DateAndTimeSplitor(this.item.end)[0]
    }

    if (typeof this.item.isAllDayEvent == typeof '') {
      this.item.isAllDayEvent = (this.item.isAllDayEvent as any) === 'True' ? true : false
    }

    //Object.assign(this.localRecurrence, this.currentRecurring)

    if (this.$route.query.pvalue) {
      let _occitem = this.$route.query.pvalue as string
      if (_occitem) {
        this.saveItem = JSON.parse(decodeURIComponent(_occitem)) as calendar.CalendarItem
      }
      Object.assign(this.item, this.saveItem)
    }

    if (!this.item) {
      this.setCalendarItem(this.editItem)
    }

    if (this.item.parentId) {
      var folder = this.folderListTree.mylist.items.filter((x: any) => x.id  == this.item.parentId)[0]
      this.setFolder(folder)
    }

    api.db_resourceReserve.getConferenceResource(this.User.comCode).then((res: any[]) => {
      this.conferenceList = res
      this.conferenceReserveCheck();
    })
  }

  conferenceReserveCheck() {
    api.db_resourceReserve.getMapByCalendarItemId(encodeURIComponent(this.item.id)).then((res: any) => {
        if (res) {
            this.reserveRequestItem = res
            this.conferenceId = res.reserveResourceId
            this.reserveRequestId = res.reserveRequestId
            this.conference = this.conferenceList.find((x: any) => x.resourceId == this.reserveRequestItem?.reserveResourceId)
            //this.$emit('setReserveRequestItem', this.reserveRequestItem)

            this.setMeetingRoom(this.conference)
        }
    })
  }
}
